import React from 'react';

export const AppCtx = React.createContext(null);
